import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { HuggingFaceAiProviderForm } from '@modules/ai/common/forms/hugging-face-ai-provider-form/hugging-face-ai-provider-form';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { GeneralProviderFormWrapper } from '../common/general-provider-form-wrapper';
export function HuggingFaceAiConfiguration(props) {
    const { provider, className, form, availableProvider } = props;
    const { fieldState } = useController({ name: `provider.huggingFace`, control: form.control });
    return (_jsx(GeneralProviderFormWrapper, { label: "Hugging Face", withTestConnection: true, className: className, fieldState: fieldState, ...props, ...assignTestId(provider.id), children: _jsx(HuggingFaceAiProviderForm, { form: form, availableProvider: availableProvider }) }));
}
